import WhatsNewRegain from '../components/WhatsNewRegain';

const WHATS_NEW_REGAIN_ROUTES = [
  {
    id: 'whats_new_regain',
    path: '/whats_new_regain',
    component: WhatsNewRegain,
    exact: true
  }
];

export default WHATS_NEW_REGAIN_ROUTES;
